import { useSearchParams } from 'react-router-dom';

/**
 * useEmbeddedMode (iter164)
 *
 * Returns `true` when the current page is being rendered inside an
 * onboarding popup iframe (which appends `?embedded=1` to the URL).
 *
 * When embedded:
 *   - The page must NOT call usePageHeader (the popup owns its own
 *     header/drag handle).
 *   - The page must NOT use its `min-h-screen` wrapper — the popup
 *     constrains height to ~80vh and provides its own scroll.
 *   - On step completion the page calls `postEmbeddedStepComplete`
 *     so the popup auto-closes and HomePage flips the step.
 */
export function useEmbeddedMode() {
  const [params] = useSearchParams();
  return params.get('embedded') === '1';
}

/**
 * Notify the parent window that the onboarding step the user is
 * working on is complete. The popup container listens for this
 * message on HomePage and (a) closes the popup, (b) flips the
 * underlying user flag, (c) refreshes auth state so the rest of the
 * app updates without a refresh.
 */
export function postEmbeddedStepComplete(stepKey, extra = {}) {
  try {
    window.parent?.postMessage(
      { type: 'onboarding:step-complete', stepKey, ...extra },
      window.location.origin,
    );
  } catch (e) { /* parent not available */ }
}
